import reused from './reused';

export default [
	reused.articleCarousel
]
